export const compoundData = [
  { id: 1, korean: "출장", english: "business trip" },
  { id: 2, korean: "영업일", english: "business day" },
  { id: 3, korean: "영업 시간", english: "business hours" },
  { id: 4, korean: "사업 계획", english: "business plan" },
  { id: 5, korean: "사업 전략", english: "business strategy" },
  { id: 6, korean: "사업 계약", english: "business contract" },
  { id: 7, korean: "사업 성장", english: "business growth" },
  { id: 8, korean: "기업 정책", english: "corporate policy" },
  { id: 9, korean: "기업 전략", english: "corporate strategy" },
  { id: 10, korean: "기업 문화", english: "corporate culture" },
  { id: 11, korean: "사무 용품", english: "office supplies" },
  { id: 12, korean: "사무 환경", english: "office environment" },
  { id: 13, korean: "사무 장비", english: "office equipment" },
  { id: 14, korean: "사무실 공간", english: "office space" },
  { id: 15, korean: "작업장 안전", english: "workplace safety" },
  { id: 16, korean: "회의실", english: "conference room" },
  { id: 17, korean: "회의 일정", english: "conference schedule" },
  { id: 18, korean: "회의 안건", english: "meeting agenda" },
  { id: 19, korean: "회의록", english: "meeting minutes" },
  { id: 20, korean: "발표 기술", english: "presentation skills" },
  { id: 21, korean: "광고 캠페인", english: "advertising campaign" },
  { id: 22, korean: "광고 예산", english: "advertising budget" },
  { id: 23, korean: "광고 전략", english: "advertising strategy" },
  { id: 24, korean: "마케팅 전략", english: "marketing strategy" },
  { id: 25, korean: "마케팅 조사", english: "marketing research" },
  { id: 26, korean: "마케팅 캠페인", english: "marketing campaign" },
  { id: 27, korean: "판매 전략", english: "sales strategy" },
  { id: 28, korean: "영업부", english: "sales department" },
  { id: 29, korean: "매출 증가", english: "sales increase" },
  { id: 30, korean: "고객 만족", english: "customer satisfaction" },
  { id: 31, korean: "채용 공고", english: "job opening" },
  { id: 32, korean: "지원자", english: "job applicant" },
  { id: 33, korean: "면접", english: "job interview" },
  { id: 34, korean: "직무 설명", english: "job description" },
  { id: 35, korean: "채용 절차", english: "hiring process" },
  { id: 36, korean: "채용 결정", english: "hiring decision" },
  { id: 37, korean: "직원 복지", english: "employee benefits" },
  { id: 38, korean: "직원 성과", english: "employee performance" },
  { id: 39, korean: "직원 교육", english: "employee training" },
  { id: 40, korean: "성과 평가", english: "performance evaluation" },
  { id: 41, korean: "재무제표", english: "financial statement" },
  { id: 42, korean: "재무 보고서", english: "financial report" },
  { id: 43, korean: "재무 성과", english: "financial performance" },
  { id: 44, korean: "재무 계획", english: "financial planning" },
  { id: 45, korean: "예산 계획", english: "budget planning" },
  { id: 46, korean: "예산 삭감", english: "budget cut" },
  { id: 47, korean: "예산 증가", english: "budget increase" },
  { id: 48, korean: "회계 부서", english: "accounting department" },
  { id: 49, korean: "투자 전략", english: "investment strategy" },
  { id: 50, korean: "투자 결정", english: "investment decision" },
  { id: 51, korean: "공급망", english: "supply chain" },
  { id: 52, korean: "공급 부족", english: "supply shortage" },
  { id: 53, korean: "공급과 수요", english: "supply demand" },
  { id: 57, korean: "건강 혜택", english: "health benefits" },
  { id: 58, korean: "식비 보조금", english: "meal allowance" },
  { id: 59, korean: "주차 허가증", english: "parking permit" },
  { id: 60, korean: "안전 규정", english: "safety regulations" },
  { id: 61, korean: "교육 세션", english: "training session" },
  { id: 62, korean: "회사 수익", english: "company revenue" },
  { id: 63, korean: "임원진", english: "executive board" },
  { id: 64, korean: "집행 위원회", english: "executive committee" },
  { id: 65, korean: "시장 수요", english: "market demand" },
  { id: 66, korean: "손익계산서", english: "income statement" },
  { id: 67, korean: "세금 신고", english: "tax return" },
  { id: 68, korean: "세금 공제", english: "tax deduction" },
  { id: 69, korean: "비용 절감", english: "cost reduction" },
  { id: 70, korean: "재정 안정성", english: "financial stability" },
  { id: 71, korean: "임대 계약", english: "lease agreement" },
  { id: 72, korean: "기밀 계약", english: "confidential agreement" },
  { id: 73, korean: "책임 보장", english: "liability coverage" },
  { id: 74, korean: "특허 신청", english: "patent application" },
  { id: 75, korean: "저작권 보호", english: "copyright protection" },
  { id: 76, korean: "상표 등록", english: "trademark registration" },
  { id: 77, korean: "법적 준수", english: "legal compliance" },
  { id: 78, korean: "법원 판결", english: "court decision" },
  { id: 79, korean: "서비스 이용 약관", english: "terms of service" },
  { id: 80, korean: "여행 제한", english: "travel restrictions" },
  { id: 81, korean: "여행 경비 환급", english: "travel reimbursement" },

  { id: 82, korean: "인프라 개발", english: "infrastructure development" },
  { id: 83, korean: "인재 채용", english: "talent acquisition" },
  { id: 84, korean: "전략적 파트너십", english: "strategic partnership" },
  { id: 85, korean: "다국어 지원", english: "multilingual support" },
  { id: 86, korean: "시 관계자", english: "city official" },
  { id: 87, korean: "의료 전문가", english: "medical professional" },
  { id: 88, korean: "급여 인상", english: "salary increase" },
  { id: 89, korean: "공인 인물", english: "public figure" },
];
